const Segment = ({ children }) => {
    return (
        <div className="ui-segment__usable" style={{padding: '45px 0px'}}>
            {children}
        </div>
    )
}

export default Segment